import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../directives/directives.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SupportUserMembershipListComponent } from './support-user-membership-list/support-user-membership-list';



@NgModule({
  declarations: [
    SupportUserMembershipListComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class SupportUserMembershipListModule {
  customElementComponent: Type<any> = SupportUserMembershipListComponent;
}
